import { Skeleton } from '@mantine/core'

// Card primitives of the appointment detail preview (mockup redesign), shared by
// AppointmentBlocks and the Kate check-in card.

export type BadgeTone = 'coral' | 'green' | 'blue' | 'gray'
export const BADGE_TONE: Record<BadgeTone, string> = {
  coral: 'bg-[#FDECE8] text-[#E5533D]',
  green: 'bg-[#E6F6EC] text-[#1A8245]',
  blue: 'bg-[#E7EEFB] text-[#2C5FE0]',
  gray: 'bg-[#F1F3F5] text-[#697386]',
}
export const CardBadge = ({ label, tone }: { label: string; tone: BadgeTone }) => (
  <span
    className={`shrink-0 rounded-full px-2 py-[3px] text-[10px] font-bold uppercase ${BADGE_TONE[tone]}`}
  >
    {label}
  </span>
)

export const DetailCard = ({
  icon,
  title,
  subtitle,
  badge,
  action,
  children,
}: {
  icon: React.ReactNode
  title: string
  subtitle?: React.ReactNode
  badge?: React.ReactNode
  action?: React.ReactNode
  children: React.ReactNode
}) => (
  <div className="rounded-2xl border border-[#E7E9EC] bg-white p-3.5">
    <div className="mb-3 flex items-start gap-2.5">
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#F1F3F7] text-[#6B7280]">
        {icon}
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-[13.5px] font-bold text-[#1F2733]">{title}</div>
        {subtitle && <div className="truncate text-[11px] text-[#6B7280]">{subtitle}</div>}
      </div>
      {badge}
      {action}
    </div>
    {children}
  </div>
)

// Shaded placeholder rows shown inside a card while its live data is loading.
export const CardSkeleton = ({ rows = 3 }: { rows?: number }) => (
  <div className="flex flex-col gap-2.5 py-0.5">
    {Array.from({ length: rows }).map((_, i) => (
      <Skeleton key={i} height={13} radius="sm" />
    ))}
  </div>
)

export const ActionButton = ({
  icon,
  label,
  coral,
  disabled,
  onClick,
}: {
  icon: React.ReactNode
  label: string
  coral?: boolean
  disabled?: boolean
  onClick: (e: React.MouseEvent) => void
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`inline-flex flex-1 items-center justify-center gap-1.5 rounded-lg border border-[#E7E9EC] bg-white px-2.5 py-[3px] !text-[12px] !font-bold whitespace-nowrap hover:bg-[#F7F8FA] disabled:cursor-default disabled:opacity-60 ${coral ? 'text-[#E5533D]' : 'text-[#33383F]'}`}
  >
    {icon}
    {label}
  </button>
)
